

export const fullHeight = () => {
    const fullHeight = document.querySelectorAll('.full-height');
    const header = document.querySelector('.fixed-header');

    let navHeight = header.offsetHeight;

    fullHeight.forEach(function (item, i) {
        item.style.height = (100 - ((navHeight / window.innerHeight) * 100)) + 'vh';

        // if (i === fullHeight.length - 1) {
        //     ScrollTrigger.refresh();
        // }
    });
}


export const minFullHeight = () => {
    const fullMinHeight = document.querySelectorAll('.full-minheight');
    const header = document.querySelector('.fixed-header');
    let navHeight = header.offsetHeight;

    fullMinHeight.forEach(function (item, i) {
        item.style.minHeight = (100 - ((navHeight / window.innerHeight) * 100)) + 'vh';


        // if (i === fullMinHeight.length - 1) {
        //     ScrollTrigger.refresh();
        // }
    });
}


